import React, { useEffect } from 'react';
import { MdChat, MdChatBubble } from 'react-icons/md';
import { Container, Sponsor, SponsorGrid } from './styles';
import { Button } from '../../components/Button/styles';
import Sponsors from '../SponsorsPage';
import Particles from 'react-particles-js';
import ImageSliderBackground from '../../components/ImageBackgroundSlider';
import RodapeLP from '../Home/modules/RodapeLP';
import Whatsapp from '../../components/Whatsapp';
import { ContactIcons } from 'src/components/MenuOld';
import { getYear } from 'date-fns';

const FooterLayout: React.FC = ({ children }) => {
  return (<><div style={{ background: '#38a5df', position: 'relative', zIndex: 1, display: 'block' }}>

    {/* <ImageSliderBackground slides={['/apoio/fundo1.jpg', '/apoio/fundo2.jpg', '/apoio/fundo3.jpg']} /> */}
    <div style={{ width: '100%', marginTop: '10px' }} />

    { /*  <div tabIndex={0} className='gap-bg column ' style={{ position: 'relative', minHeight: '10vh', padding: '0px 15px', background: '#fff', zIndex: 900000 }}>

      <div className='full-width ' style={{ zIndex: 1 }}>


        <Sponsors />

      </div>



    </div>
*/}

    <div className='row-to-column max-1200 full-width' style={{ gap: '50px', alignItems: 'center', justifyContent: 'flex-start', zIndex: 2, position: 'relative', margin: '0px auto', padding: '30px 10px', paddingBottom: '10px' }}>


      <div>
        <img src="/assets/logo.png" style={{ width: '300px', maxWidth: '100%' }} />
      </div>

      <div className='column-start ' style={{ gap: '15px' }}>
        <a style={{ color: '#fff', fontSize: '16px' }} href="/">Home</a>
        <a style={{ color: '#fff', fontSize: '16px' }} href="/termos">Política de privacidade</a>
      </div>
    </div>
    <div className='column max-1200 full-width' style={{ alignItems: 'flex-end', zIndex: 2, position: 'relative', gap: '15px', justifyContent: 'space-between', margin: '0px auto', padding: '10px 10px' }}>


      <ContactIcons color="#fff" />
      <p style={{ color: '#fff', fontSize: '14px', width: '100%', textAlign: 'right' }} >UFCSPA © 2025 Todos os direitos reservados.</p>

    </div>
  </div>

  </>
  );
};

export default FooterLayout;
